import { Box, Button, Text } from "@origin-digital/ods-core";
import * as React from "react";
import FormContext from "src/context/FormContext";
import { fromHyphenatedToCamelCase } from "../helper";
import { styled } from "@mui/material";
import { IconError, IconWarning } from "@origin-digital/ods-icons";
import { normaliseIdColumnValue } from "src/components/Changes/helpers";

interface ISidebarItemProps {
  name: string;
  id: string;
  onSelect: () => void;
  icon?: "warning" | "error";
  activeSection?: string;
  journeyId?: string;
  requestId?: string;
  distributorApplicationId?: string;
}

const SidebarItemButton = styled(Button)(() => ({
  width: "100% !important",
  height: "100% !important",
  padding: "16px 24px !important",
  borderRadius: "0px !important",
  display: "flex",
  justifyContent: "space-between",
}));

const SidebarItem = (props: ISidebarItemProps) => {
  const {
    name,
    onSelect,
    id,
    icon,
    activeSection,
    journeyId,
    requestId,
    distributorApplicationId,
  } = props;
  const { currentlyActiveBlock, setBlocksExpanded, blocksExpanded } =
    React.useContext(FormContext);

  const iconMapping = {
    warning: <IconWarning color="caution" />,
    error: <IconError color="critical" />,
  };
  const isActive = [currentlyActiveBlock, activeSection].includes(id);
  return (
    <SidebarItemButton
      component="a"
      variant="text"
      size="small"
      // @ts-expect-error: invalid endIcon type error
      endIcon={icon ? iconMapping[icon] : undefined}
      style={{}}
      onClick={() => {
        if (blocksExpanded[fromHyphenatedToCamelCase(id)]) {
          onSelect();
        } else {
          setBlocksExpanded({
            ...blocksExpanded,
            [fromHyphenatedToCamelCase(id)]: true,
          });
          setTimeout(() => {
            onSelect();
          }, 400);
        }
      }}
    >
      {/* //TODO: update ods to support gap prop */}
      <Box display="flex" flexWrap="wrap">
        <Text
          weight="medium"
          tone={isActive ? "critical" : "neutralDark"}
          /* @ts-expect-error: paddingRight is not a valid prop */
          paddingRight="xsmall"
        >
          {name}
        </Text>
        {requestId && (
          <Text tone="neutralLight">
            (
            {normaliseIdColumnValue(
              requestId,
              journeyId,
              distributorApplicationId
            )}
            )
          </Text>
        )}
      </Box>
    </SidebarItemButton>
  );
};

export default SidebarItem;
